import {defineSlotRecipe} from '@chakra-ui/react3'

export const ratingsTextRecipe = defineSlotRecipe({
    slots: ['ratingValue', 'ratingCount', 'container', 'button', 'starContainer', 'full'],
    base: {
        ratingValue: {display: 'none'},
        ratingCount: {display: 'none'},
        container: {
            alignItems: 'center'
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            height: 'auto',
            p: '0',
            gap: 0
        },
        starContainer: {
            height: '1rem',
            width: '1rem',
            display: 'flex',
            _icon: {
                width: '0.875rem',
                height: '0.875rem'
            }
        }
    },
    variants: {
        variant: {
            productTile: {
                ratingCount: {
                    display: 'block',
                    textStyle: 'body.xsmall',
                    color: 'text.secondary',
                    ms: 'spacing-8'
                }
            },
            cockpit: {
                ratingCount: {
                    display: 'block',
                    textStyle: 'body.xsmall',
                    color: 'text.secondary',
                    ms: 'spacing-8'
                },
                container: {
                    cursor: 'pointer'
                }
            },
            pdpSpec: {
                ratingValue: {
                    display: 'block',
                    textStyle: 'heading.xlarge',
                    me: 'spacing-8'
                }
            },
            reviewsModule: {
                ratingValue: {
                    display: 'block',
                    textStyle: 'display.medium',
                    me: 'spacing-10'
                },
                ratingCount: {
                    display: 'block',
                    color: 'text.secondary',
                    textStyle: 'body.small',
                    ms: 'spacing-10'
                }
            },
            review: {}
        }
    }
})
